import AuthLayout from '@v2/domains/auth/layout/Auth.layout'
import AppLayout from '@v2/domains/layout/components/AppLayout'
import { checkRoute } from '@v2/domains/routing/actions/routing.actions'
import { getRouteObjects } from '@v2/domains/routing/constants/routes.constants'
import { selectCurrentOrganization } from '@v2/domains/user/selectors/user.selectors'
import { useLayoutEffect } from 'react'
import { RouterProvider, createBrowserRouter } from 'react-router-dom'

import AttachmentPage from 'src/common/pages/Private/AttachmentPage'
import NotFoundPage from 'src/common/pages/Stuff/NotFoundPage/NotFoundPage'

import { BENESTREAM_ORG_ID } from './common/config'
import { useAppDispatch, useAppSelector } from './v2/store/hooks'

const createAppRouter = (isBenestream: boolean) => {
  const platform = isBenestream ? 'benestream' : 'default'
  const routeObjects = getRouteObjects(platform)

  return createBrowserRouter([
    {
      path: '/',
      element: <AuthLayout />,
      children: routeObjects.filter(
        (route) =>
          route.path === 'login' ||
          route.path === 'forgot' ||
          route.path === 'reset-password' ||
          route.path === 'select-organization',
      ),
    },
    {
      path: ':organizationName',
      element: <AppLayout />,
      children: routeObjects.filter(
        (route) =>
          route.path !== 'login' &&
          route.path !== 'forgot' &&
          route.path !== 'reset-password' &&
          route.path !== 'select-organization',
      ),
    },
    {
      path: 'attachment/:attachmentId/:attachmentType',
      element: <AttachmentPage />,
    },
    {
      path: 'not-found',
      element: <NotFoundPage />,
    },
    {
      path: '*',
      element: <NotFoundPage />,
    },
  ])
}

const AppRoutes = () => {
  const dispatch = useAppDispatch()
  const currentOrganization = useAppSelector(selectCurrentOrganization)

  const isBenestream = currentOrganization?.id === BENESTREAM_ORG_ID

  const router = createAppRouter(isBenestream)

  useLayoutEffect(() => {
    dispatch(checkRoute({ skipValidation: false }))
  }, [dispatch])

  return (
    <RouterProvider router={router} fallbackElement={<div>Loading...</div>} />
  )
}

export default AppRoutes
